import renderMultiMapChild from "../renderMultiMapChild.jsx";
import renderMultiMap from "../renderMultiMap.jsx";

document.addEventListener("DOMContentLoaded", () => {
  renderMultiMapChild();
  renderMultiMap();
});
